<template>
  <div class="page">

    <!--导航栏 start-->
    <!-- <van-nav-bar title="添加商户" left-text="返回" left-arrow fixed @click-left="onClickLeft" /> -->
    <!--导航栏 end-->

    <div class="container-logo">
      <div class="txt1">你好，欢迎来到</div>
      <div class="txt2">予益商户平台</div>
    </div>

    <!--内容部分 start-->
    <van-form @submit="onSubmit" style="padding: 0 32px;background-color: #fff;">
      <div class="txt4">商户编号/门店编号</div>
      <van-field v-model="username" name="商户编号/门店编号" placeholder="请输入商户编号/门店编号"
        :rules="[{ required: true, message: '商户编号/门店编号不能为空' }]">
      </van-field>
      <div class="txt4">密码</div>
      <van-field v-model="password" type="password" name="密码" placeholder="请输入密码"
        :rules="[{ required: true, message: '密码不能为空' }]">
      </van-field>
      <div style="background-color: #fff;">
      <div style="padding-bottom: 16px;padding-top: 30px;box-sizing: border-box;">
        <van-button round block type="info" native-type="submit" @click="onSubmit">
          登录并绑定
        </van-button>
      </div>
      <div class="txt3">
        ● 点击登录即表示您同意 《用户服务协议》
      </div>
    </div>
    </van-form>
    <!--内容部分 end-->

  </div>
</template>

<script>
// import VueCookie from 'vue-cookies'
import { Notify, Toast } from 'vant'
export default {
  name: 'MerchantLogin', // 商户添加
  data() {
    return {
      username: '',
      password: ''
    }
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = '#f5f5f5'
    next()
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = ''
    next()
  },
  methods: {
    // 左侧返回
    onClickLeft() {
      this.$router.push('/MerchantImpower')
      // window.history.go(-1)
    },
    // 提交
    onSubmit() {
      // window.sessionStorage.setItem("tag",this.ta)
      //  var that = this;
      var toast = Toast.loading({
        duration: 0,
        message: '添加中',
        forbidClick: true,
        loadingType: 'spinner'
      })
      // 商户
      this.$http.get('/wechat/user/merchant_login', {
        params: {
          username: this.username,
          password: this.password,
          openid: window.localStorage.getItem('openid')
        }
      }).then(response => {
        toast.clear()
        if (response && response.data.code == 200) {
          this.$router.push('/MerchantImpower')
          // VueCookie.set('salesmanInfo', response.data.data, 360000);
          // window.location.href = that.redirect;
        } else {
          if(response.data.msg == '用户名或密码不正确'){
            Notify({ type: 'danger', message: response.data.msg })
          }else{
            // 门店
          this.$http.get('/wechat/user/store_login', {
            params: {
              username: this.username,
              password: this.password,
              openid: window.localStorage.getItem('openid')
            }
          }).then(response => {
            toast.clear()
            console.log(response.data)
            if (response && response.data.code == 200) {
              this.$router.push('/MerchantImpower')
              // VueCookie.set('salesmanInfo', response.data.data, 360000);
              // window.location.href = that.redirect;
            } else {
              Notify({ type: 'danger', message: response.data.msg })
            }
          })
          }
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .van-field__control::-webkit-input-placeholder{
  color: #999 !important;
}

.page {
  width: 100%;
  height: 100vh;
  background-color: #fff;
}

.container-logo {
  width: 100%;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  padding: 0 32px;
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 4%, rgba(20, 134, 251, 1) 192%);

  .txt1 {
    font-weight: 300;
    font-style: normal;
    font-size: 20px;
    letter-spacing: 1px;
    line-height: 50px;
    color: #333333;
  }

  .txt2 {
    font-weight: 700;
    font-style: normal;
    font-size: 26px;
    letter-spacing: 2px;
    line-height: 50px;
    color: #333333;
  }
}

.txt3 {
  font-size: 14px;
  color: #999999;
  font-weight: 400;
  line-height: 20px;
}

.txt4 {
  line-height: 50px;
  font-size: 12px;
  color: rgba(170, 170, 170, 0.9);
}
</style>
